import { selectNewbuildingFlightEntryUrl } from './selectNewbuildingFlightEntryUrl';
import { IAppState } from '../../common/state';

export function selectNewbuildingFlightBannerAvailable(state: IAppState) {
  return Boolean(selectNewbuildingFlightEntryUrl(state));
}
